module.exports = __webpack_public_path__ + "5a12ec1d.png";